import React from 'react';
import { useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setActiveModalAction } from '../../../action';
import swal from 'sweetalert';
import ActionMenu from "../../../components/utils/ActionMenu";
import { roleId } from '../../../constants/app';
import { deleteRaw } from '../../../action/raw';
import { MEASURES_RAW } from '../../rawmaterials/constansts';
import { getReceipesByIngredient } from '../../../action/recipes';
import { parseNumToFixed } from '../../../utils/common';

const Item = ({ item, history }) => {
    const dispatch = useDispatch();
    const loaderUpdateRaw = useSelector(fromStore.loaderUpdateRawSelector);
    const loaderDeleteRaw = useSelector(fromStore.loaderDeleteRawSelector);
    const loaderUpdate = loaderUpdateRaw === item.id;
    const loadertDelete = loaderDeleteRaw === item.id;
    const user = useSelector(state => state.user.info);

    const openDetail = () => {
        history.push(`/accounting/semimanufactures/${item.id}`);
    };

    const onOpenModalRaw = (id) => {
        const raw = id || 'new';
        dispatch(setActiveModalAction({ field: 'modalRaw', value: { id: raw, type: 'semi' } }));
    }

    const onDeleteRaw = async () => {
        const receipes = await dispatch(getReceipesByIngredient(item.id, null, 'semi', true));
        
        if (receipes && receipes.length > 0) return swal({
            title: `Удаление полуфабриката невозможно`,
            text: `Полуфабрикат используется в рецептах.`,
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });
        
        return swal({
            title: `Удаление полуфабриката`,
            text: `Вы действительно хотите удалить ${item.name}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) dispatch(deleteRaw(item.id));
        });
    }

    const actions = [
        { name: 'Просмотр',  icon: 'la la-eye', action: () => openDetail()},
        { name: 'Редактировать', icon: 'la la-edit', action: () => onOpenModalRaw(item.id)},
        { name: 'Удалить', access: [roleId.admin, roleId.chiefCommoditySpecialist, roleId.chiefMarketingSpecialist], icon: 'la la-trash', action: () => onDeleteRaw()}
    ].filter((item) => !item.access || item.access.includes(user.role.id));    

    if(window.innerWidth > 730)
        return (
            <tr key={`${item.id}_good`} className="kt-datatable__row" onDoubleClick={openDetail}>
                <td className='kt-datatable__cell good_id'><span>{item.id}</span></td>
                <td className='kt-datatable__cell'><span>{item.name}</span></td>
                <td className='kt-datatable__cell good_info'><span>{item.weight} {MEASURES_RAW[item.measure]}</span></td>
                <td align='right' className='kt-datatable__cell table_action'>
                    <div style={{ width: '100%', height: '100%', display: 'flex', gap: '5px' }}>
                        {!loadertDelete && !loaderUpdate && <ActionMenu actions={actions}/>} 
                        {(loadertDelete || loaderUpdate) && <span style={{overflow: 'visible', position: 'relative', width: '80px'}}><button className='btn btn-sm btn-clean btn-icon btn-icon-md kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger'></button></span> }
                    </div>
                </td>
            </tr>
        );

    return (
        <tr key={`${item.id}_good`} className="kt-datatable__row" onDoubleClick={openDetail}>
            <div className='goods_list_mobile main_row'>
                <div className='goods_list_mobile row'>                    
                    <div className="goods_list_mobile good_info"><span>{'ID: '}<span style={{color: '#000'}}>{item.id}</span></span></div>
                    <div className="goods_list_mobile good_name"><span style={{color: '#000'}}>{item.name}</span></div>                   
                </div>
                {window.innerWidth > 430 
                ?
                <div className='goods_list_mobile row'  style={{justifyContent: 'space-between', gap: 0}}>                    
                        <div className='mobile_div_flex gap5px'>
                            <div className="goods_list_mobile good_info"><span>{'Вес/объем: '}<span style={{color: '#000'}}>{parseNumToFixed(item.weight, 3)} {MEASURES_RAW[item.measure]}</span></span></div>
                        </div>
                        <div align='right' className="goods_list_mobile good_action">
                            <div  className='mobile_div_flex gap5px' style={{width: '100%', height: '100%' }}>
                                {!loadertDelete && !loaderUpdate && <ActionMenu actions={actions}/>} 
                                {(loadertDelete || loaderUpdate) && <span style={{overflow: 'visible', position: 'relative', width: '80px'}}><button className='btn btn-sm btn-clean btn-icon btn-icon-md kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger'></button></span> }
                            </div>     
                        </div>           
                    </div>         
                    :
                    <div className='goods_list_mobile row'>
                            <div className="goods_list_mobile good_info"><span>{'Вес/объем: '}<span style={{color: '#000'}}>{item.weight} {MEASURES_RAW[item.measure]}</span></span></div>
                    </div>
                }
                
                {window.innerWidth <= 430 && 
                <div className='goods_list_mobile row'>
                    <div className="goods_list_mobile good_info"></div>
                    <div align='right' className="goods_list_mobile good_action">
                        <div style={{width: '100%', height: '100%', display: 'flex', gap: '5px' }}>
                            {!loadertDelete && !loaderUpdate && <ActionMenu actions={actions}/>} 
                            {(loadertDelete || loaderUpdate) && <span style={{overflow: 'visible', position: 'relative', width: '80px'}}><button className='btn btn-sm btn-clean btn-icon btn-icon-md kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger'></button></span> }
                        </div>     
                    </div>
                </div>
                }
            </div>
        </tr>
    );
}

export const ItemRow = withRouter(Item);